/**
 * Hook into Alpine so that it is available no matter at which point Alpine loads.
 */
document.addEventListener('alpine:init', () => {
    /**
     * Manages dialogs across ASAPConnect.
     */
    Alpine.store('dialog', {
        /**
         * @var object configuration state of the dialog
         */
        config: {
            buttons:             [],
            title_translation:   '',
            content_translation: '',
        },

        /**
         * @var bool true if the dialog is currently visible
         */
        visible: false,

        /**
         * Set any prerequisites.
         *
         * @return void
         */
        init() {
            Livewire.on('dialog', (config) => this.show(config));
        },

        /**
         * Emit a custom event based on a dialog action.
         *
         * @param string event the event to emit
         *
         * @return void
         */
        emit(event) {
            this.hide();
            Livewire.dispatch(event);
        },

        /**
         * Show the dialog.
         *
         * @param array containing the configuration from config('dialog.*')
         *
         * @return void
         */
        show(config) {
            this.config  = config;
            this.visible = true;
        },

        /**
         * Hide the dialog.
         *
         * @return void
         */
        hide() {
            this.visible = false;
        },
    });
});
